import { objectSchema } from "vue-utils"
import type { INamed, IncidentEntity } from "./IncidentEntity"

export interface IncidentType extends IncidentEntity, INamed {}

export const IncidentType = objectSchema<IncidentType>({
	id: Number,
	name: String,
})
